const env = require('/opt/build/repo/twing/environment.js');
let templatesModule = (() => {
let module = {
    exports: undefined
};

module.exports = (TwingTemplate) => {
    return new Map([
        [0, class extends TwingTemplate {
            constructor(env) {
                super(env);

                this.source = this.getSourceContext();
                this.macros = new this.Context();
                let macros = new this.Context();

                this.parent = false;

                this.blocks = new Map([
                ]);
            }

            doDisplay(context, blocks = new Map()) {
                let macros = this.macros.clone();
                this.echo(this.include(context, this.source, this.loadTemplate(`cc08bb4c6b56e29f29706f9fad5b32004a78e834b77094468fe413017b01a48f`, `cc08bb4c6b56e29f29706f9fad5b32004a78e834b77094468fe413017b01a48f`, 1, 110), new Map([[`class`, `o-container--pad`]]), false, false, 1));
            }

            getTemplateName() {
                return `cc08bb4c6b56e29f29706f9fad5b32004a78e834b77094468fe413017b01a48f`;
            }

            isTraitable() {
                return false;
            }

            getSourceContext() {
                return new this.Source(``, `cc08bb4c6b56e29f29706f9fad5b32004a78e834b77094468fe413017b01a48f`, ``);
            }
        }],
        [110, class extends TwingTemplate {
            constructor(env) {
                super(env);

                this.source = this.getSourceContext();
                this.macros = new this.Context();
                let macros = new this.Context();

                this.parent = this.loadTemplate(`@cloudfour/objects/container/container.twig`, `cc08bb4c6b56e29f29706f9fad5b32004a78e834b77094468fe413017b01a48f`, 1);

                this.blocks = new Map([
                    ['content', [this, 'block_content']]
                ]);
            }

            doGetParent(context) {
                return `@cloudfour/objects/container/container.twig`;
            }

            doDisplay(context, blocks = new Map()) {
                let macros = this.macros.clone();
                this.parent.display(context, this.merge(this.blocks, blocks));
            }

            block_content(context, blocks = new Map()) {
                let macros = this.macros.clone();
                this.echo(`    <p>This is default text.</p>
    <p class="u-text-action">This is text that has the utility class applied.</p>
  `);
            }

            getTemplateName() {
                return `cc08bb4c6b56e29f29706f9fad5b32004a78e834b77094468fe413017b01a48f`;
            }

            isTraitable() {
                return false;
            }

            getSourceContext() {
                return new this.Source(``, `cc08bb4c6b56e29f29706f9fad5b32004a78e834b77094468fe413017b01a48f`, ``);
            }
        }],
    ]);
};

    return module.exports;
})();

env.registerTemplatesModule(templatesModule, 'cc08bb4c6b56e29f29706f9fad5b32004a78e834b77094468fe413017b01a48f');

let template = env.loadTemplate('cc08bb4c6b56e29f29706f9fad5b32004a78e834b77094468fe413017b01a48f');

module.exports = (context = {}) => {
    const rendered = template.render(context);
     const inputs = window.__twig_inputs__ || (window.__twig_inputs__ = new Map());
     inputs.set(
       rendered,
       { path: "@cloudfour/utilities/text/demo/color.twig", args: context }
     );
     return rendered;;
};